import axiosInstance from 'plugins/axios';
import { IBodyResponse } from 'types/type.global';
import {
    ICampaignListQuestionResponse,
    ICampaignLogicPageListQuestionResponse,
} from 'types/campaign';
import {
    ICheckQuotaPayload,
    ICheckQuotaResponse,
    IGeoCoords,
} from 'types/previewCampaign';
import { IGroup } from 'types/user';
import { objectToFormData, applyTokenToUrl } from 'utils/helpers';

interface IPreviewSurveyInfo {
    me: any; // eslint-disable-line @typescript-eslint/no-explicit-any
    survey: any; // eslint-disable-line @typescript-eslint/no-explicit-any
    groups?: IGroup[];
}

export const fetchPreviewInfo = async (
    campaignId: number | string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<
    IBodyResponse<IPreviewSurveyInfo & ICampaignListQuestionResponse>
> => {
    const response = await axiosInstance.get(
        applyTokenToUrl(`preview_survey/${campaignId}/infos`)
    );
    return response.data;
};

export const fetchLogicPageSurveyInfo = async (
    campaignId: number | string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<
    IBodyResponse<IPreviewSurveyInfo & ICampaignLogicPageListQuestionResponse>
> => {
    const response = await axiosInstance.get(
        applyTokenToUrl(`preview_survey/${campaignId}/infos`)
    );
    return response.data;
};

export const fetchTargetedSurvey = async (
    campaignId: string,
    code = ''
): Promise<
    IBodyResponse<IPreviewSurveyInfo & ICampaignListQuestionResponse>
> => {
    console.log(code);
    const response = await axiosInstance.get(
        applyTokenToUrl(`preview_survey_ipad/${campaignId}/infos`, code)
    );
    return response.data;
};

export const fetchListInvite = async (
    campaignId: number | string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.get(
        applyTokenToUrl(`preview_survey/${campaignId}/shares`)
    );
    return response.data;
};

export const fetchListUsersInvite = async (
    campaignId: number | string,
    keyword: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.get(
        applyTokenToUrl(
            `preview_survey/${campaignId}/shares/search_users?keyword=${keyword}`
        )
    );
    return response.data;
};

export const createInviteUser = async (
    campaignId: number | string,
    data: {
        emails: string;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    const response = await axiosInstance.post(
        applyTokenToUrl(`preview_survey/${campaignId}/shares`),
        data
    );
    return response.data;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const formatAnswerData = (data: any): any => {
    return data;
};

export const createAnswers = async (
    campaignId: number | string,
    data: any, // eslint-disable-line @typescript-eslint/no-explicit-any
    timeStamp: Record<string, number>,
    quotas?: any[], // eslint-disable-line @typescript-eslint/no-explicit-any
    geo?: IGeoCoords | null
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<IBodyResponse<any>> => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const payload: any = {
        answers: formatAnswerData(data),
        time_stamp: timeStamp,
    };

    if (quotas && quotas.length > 0) {
        payload.quotas = quotas;
    }

    if (geo) {
        payload.lat = geo.lat;
        payload.lng = geo.long;
    }

    const formData = objectToFormData(payload);
    const response = await axiosInstance.post(
        applyTokenToUrl(`preview_survey/${campaignId}/answers`),
        formData
    );
    return response.data;
};

export const checkQuota = async (
    token: string | null,
    surveyId: number,
    data: ICheckQuotaPayload
): Promise<IBodyResponse<ICheckQuotaResponse>> => {
    const url = token
        ? `/preview_survey/${surveyId}/quotas/check?token=${token}`
        : `/preview_survey/${surveyId}/quotas/check`;
    const response = await axiosInstance.post(url, data);
    return response.data;
};
